import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=3a2a71bc&"
import script from "./ProfileTabs.vue?vue&type=script&lang=js&"
export * from "./ProfileTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports